import request from '@/utils/http';
import { otpBaseUrl } from './baseUrl';

// 纯计费订单查询
export const getTplCostRouteInfos = (params) => {
    return request({
        url: `${otpBaseUrl}/tplCostRouteInfos`,
        method: 'get',
        params
    });
};

// 保存纯计费订单
export const saveCostOrderInfo = (data) => {
    return request({
        url: `${otpBaseUrl}/costOrderInfo/${data.id}`,
        method: 'put',
        data
    });
};
